import React from 'react'

const Button = ({name}) => {
  return (
   <button className='px-5 py-2 m-3 bg-gray-200 rounded-lg'>{name}</button>
  )
}

export default Button